import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AttachCandidateToCaseResponse extends BackendResponse {
  idCandidate: number;
  typeRelated: number;
  idRelated: number;
  idRecruitmentCandidate: number | null;
  idVacancyCandidate: number | null;
  idStatus: number;
  statusCaption: string;
}
export interface AttachCandidateToCaseParameters extends NextApiParams {
  typeRelated: number;
  idRelated: number;
  publicApplicantListIsOkay: boolean;
  triggerSystemEvent: boolean;
}

export const attachCandidateToCase = withNextApi<
  AttachCandidateToCaseResponse,
  AttachCandidateToCaseParameters
>("/cvp/CvpAttachCandidateToCase");
